import * as React from 'react';
import { Button, Div, P } from '@kizi/core-components';
import { PriceProps } from '.';
import { Price } from './Price';

export const NonPurchasableText = (): JSX.Element => (
  <Div variant="unavailablePriceContainer">
    <P variant="secondaryCaptionBold">Geen samenwerking met verzekeraar</P>
  </Div>
);

export const ProductOverviewModalHeader: React.FC<ProductOverviewModalHeaderProps> =
  ({ priceProps, purchasableProduct, isOverstappen, onApplyClick }) => (
    <Div display="flex" ml="auto">
      <Price {...priceProps} variant="priceMedium" mr={6} my="auto" />
      <Div my="auto">
        {purchasableProduct ? (
          <Button onClick={onApplyClick} variant="primarySmall">
            {isOverstappen ? 'Aanvragen' : "Ga verder"}
          </Button>
        ) : (
          <NonPurchasableText />
        )}
      </Div>
    </Div>
  );
interface ProductOverviewModalHeaderProps {
  priceProps: PriceProps;
  purchasableProduct: boolean;
  isOverstappen: boolean;
  onApplyClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}
